import TextToSpeechApp from '../components/TextToSpeechApp';
import React from 'react';

const Aawaz = () => {
  return <TextToSpeechApp />;
};

export default Aawaz;
